import React from "react";
import style from "./whatsappbutton.module.css";

const WhatsappButton: React.FC = () => {
  // ► 1) Número en E-164 (sin “+”, espacios ni guiones)
  const phone = "573115429203";
  const message = "Hola, Quiero hacer parte del cambio";

  // ► 2) Construye el enlace solo una vez
  const waUrl = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={waUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chatea con nosotros por WhatsApp"
      className={style.whatsappbutton}
    >
      <div className={style.alertshow}>
        <p className={style.alertshowname}>¡Estamos en línea!</p>
      </div>

      {/* icono – usa el que prefieras */}
      <img
        src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
        alt="WhatsApp"
      />
    </a>
  );
};

export default WhatsappButton;
